<proffeo-ui-dialog [title]="title">
  <p
    [innerHTML]="desc"
    class="text-base"
  ></p>
</proffeo-ui-dialog>
